module.exports = __webpack_public_path__ + "assets/img/graph-orng.webp?fff040e3509b5c1c1aa67880df01bad3";